<template>
    <v-overlay :value="dialog">
        <v-dialog
            v-model="dialog"
            persistent
            content-class="d-flex justify-center align-center"
        >
        <v-img 
            :src="require('@/assets/img/icons/icon-warning-stroke.png')"
            class="dialog-icon"
            height="80"
            width="80"
            alt="warning image"
            />
        <v-card class="border-radius-1 text-white">
            <!-- <div
                class="d-flex flex-column justify-center align-center elevation-15 result-content border-radius-2"
            >
                <div class="d-flex flex-column justify-center align-center position-relative pt-15"> -->
                    <!-- <div class="position-absolute top-bee">
                        <img :src="beeImg" alt="bee image" />
                    </div> -->
                    <div class="pa-5 mx-5 d-flex justify-center align-center flex-column">
                        <span class="text-h5 pa-5 font-weight-lighter">
                            {{ $t('challenge.do_not_be_discouraged') }}
                        </span>
                    </div>
                    <div class="px-5 mx-5">
                        <div
                            class="px-5 py-3 mx-5 d-flex align-center justify-center border-radius-2"
                        >
                            <span class="text-body-1">
                                {{ $t('challenge.try_again_msg') }}
                            </span>
                        </div>
                    </div>
                    <v-card-actions class="d-flex justify-center align-center ma-4">
                        <v-spacer></v-spacer>
                        <v-btn
                            data-cy="failModal-continue-button"
                            outlined
                            block
                            color="white"
                            class="text-transform-none"
                            @click="continueAction"
                            >
                            {{ $t('bookReading.continue') }}
                        </v-btn>
                    </v-card-actions>
                <!-- </div>
            </div> -->
        </v-card>
        </v-dialog>
    </v-overlay>
</template>
<script>
/* eslint-disable global-require */

export default {
    props: {
        dialog: { type: Boolean, default: false },
    },
    data() {
        return {
            beeImg: require('@/assets/img/bees/beeanimo.svg'),
        }
    },
    methods: {
        continueAction() {
            this.$emit('continue')
        },
    },
}
</script>
<style>
.bee-img {
    width: 15vh;
    text-align: left;
    top: 2.5vh;
    left: 2.5vh;
    line-height: 1.5vh;
}
.bee-img span {
    font-size: 12px !important;
    font-weight: 400;
    letter-spacing: 1px !important;
}
.bee-img img {
    height: 5vh;
}
.p-img {
    z-index: 300;
}
.p-img img {
    height: 20vh;
    z-index: 10;
}
.result-content {
    width: 35%;
    box-sizing: border-box;
    border: 2px solid #4bada1;
    background: radial-gradient(circle, #f4f9f9 0%, #ceecea 100%);
    box-shadow: -7px 6px 12px 5px rgba(0, 0, 0, 0.07);
}

.items-unset {
    align-items: unset !important;
}

.bright-points {
    align-items: center;
    color: #816ad6;
}

.bright-beecoin {
    align-items: center;
    color: darkgoldenrod;
}

.form-title {
    color: white;
    font-size: 2.5vw;
}

.form-text {
    font-size: 1.2vw;
    color: white;
}

.beecoin-top-1 {
    z-index: 1;
    position: relative;
    bottom: 11vh;
    left: 5vw;
}

.beecoin-top-2 {
    transform: rotate(15deg);
    position: relative;
    bottom: 13vh;
    left: 1vw;
}

.text-beecoin {
    font-size: 1vw;
}

.button-text {
    text-transform: none;
    font-size: 1vw;
}
.bee-icon-size {
    width: 16.5vh;
}
.bee-icon-size-2 {
    width: 17.5vh;
}
.z-text {
    z-index: 10;
}
.result-msg-content {
    background-color: #d5efee;
    font-weight: bold !important;
}

.top-bee {
    top: -7.5vh;
}
.top-bee img {
    width: 20vw;
    max-height: 15vh;
}

.text-white{
    color: white!important;;
}
</style>
